import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
import TopBar from '../components/TopBar';
import Api from '../utils/Api';

import "../style/ListEtablissements.css";
import buildingIcon from '../assets/building-gradient.png';

// ListEtablissements Component
class ListEtablissements extends Component {
    constructor() {
        super();
        this.state = {
            items: null,
        };
    }

    componentDidMount() {
        Api.getEtablissements()
        .then((res) => {
            this.setState({ items : res });
        }).catch(err => {
            if (err.status === 403 || err.status === 401) {
                this.setState({ logout: true });
            }
        });
    }

    getItem(item) {
        return (
            <div className="col-md-6 col-lg-6 col-xl-4" key={item.hash}>
                <Link to={`/app/etablissements/${encodeURIComponent(item.hash)}`}>
                    <div className="card etablissement-card">
                        <div className="icon-wrapper">
                            <img src={buildingIcon} alt="Building icon"/>
                        </div>
                        <div className="etablissement-text-wrapper">
                            {item.name}
                            <div className="etablissement-subheading">
                                {item.comment}
                            </div>
                        </div>
                    </div>
                </Link>
            </div>
        );
    }

    render() {
        if (this.state.logout)
            return <Redirect to="/login" />
        
        if (this.state.items && this.state.items.length === 1) {
            return <Redirect to={`/app/etablissements/${encodeURIComponent(this.state.items[0].hash)}`} />
        }

        const items = this.state.items && this.state.items.map((item) => this.getItem(item));

        return(
            <div className="route-wrapper">
                <TopBar
                    title="Mes établissements"
                    subheading="Cliquez sur un établissement pour plus de details"
                    icon="pe-7s-graph2"
                />
                <div className="app-inner-layout">
                    <div className="app-inner-layout-content">
                        <div className="container-fluid">
                            <div className="row">
                                {items}
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}
export default ListEtablissements;



// WEBPACK FOOTER //
// ./src/containers/ListEtablissements.js